import React, { lazy, Suspense } from 'react';
import { Routes, Route } from 'react-router-dom';
import Layout from './components/Layout';

const Home                = lazy(() => import('./pages/Home'));
const IndustryMap         = lazy(() => import('./pages/IndustryMap'));
const FoodHall            = lazy(() => import('./pages/FoodHall'));
const OfficesConferences  = lazy(() => import('./pages/OfficesConferences'));
const Marketplace         = lazy(() => import('./pages/Marketplace'));
const ExecutiveDining     = lazy(() => import('./pages/ExecutiveDining'));
const Kitchen             = lazy(() => import('./pages/Kitchen'));
const Shipping            = lazy(() => import('./pages/Shipping'));
const Cafe                = lazy(() => import('./pages/Cafe'));
const OutdoorDining       = lazy(() => import('./pages/OutdoorDining'));
const Solution            = lazy(() => import('./pages/Solution'));
const AboutUs             = lazy(() => import('./pages/AboutUs'));

function App() {
  return (
    <Suspense fallback={null}>
      <Routes>
        <Route path="/" element={<Layout />}>
          {/* Splash / landing */}
          <Route index element={<Home />} />

          {/* Interactive B&I map */}
          <Route path="map" element={<IndustryMap />} />

          {/* Area pages */}
          <Route path="food-hall"             element={<FoodHall />} />
          <Route path="offices-and-conferences" element={<OfficesConferences />} />
          <Route path="marketplace"           element={<Marketplace />} />
          <Route path="executive-dining"      element={<ExecutiveDining />} />
          <Route path="kitchen"               element={<Kitchen />} />
          <Route path="shipping"              element={<Shipping />} />
          <Route path="cafe"                  element={<Cafe />} />
          <Route path="outdoor-dining"        element={<OutdoorDining />} />

          {/* Solution detail */}
          <Route path="solutions/:solution"   element={<Solution />} />

          {/* About */}
          <Route path="aboutus"              element={<AboutUs />} />
          <Route path="aboutus/agilysys"     element={<AboutUs />} />
        </Route>
      </Routes>
    </Suspense>
  );
}

export default App;
